import { render, staticRenderFns } from "./AgendaTable.vue?vue&type=template&id=aa6dfe5a&scoped=true&"
import script from "./AgendaTable.vue?vue&type=script&lang=js&"
export * from "./AgendaTable.vue?vue&type=script&lang=js&"
import style0 from "./AgendaTable.vue?vue&type=style&index=0&id=aa6dfe5a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa6dfe5a",
  null
  
)

export default component.exports